import { Component, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ButtonComponent } from "@components/button/button.component";
import { ListSelectedItemsComponent } from "@components/list-selected-items/list-selected-items.component";
import { PageComponent } from "@components/page/page.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { SelectedListItem } from "~app/common/components/list-selected-items/listSelectedItems.models";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { HandelssortimentFileDownloaderComponent } from "./handelssortiment-file-downloader/handelssortiment-file-downloader.component";
import { ISearchHandelssortimentModel } from "./handelssortiment.models";
import { SearchPanelComponent } from "./search-panel/search-panel.component";
import { SearchResultComponent } from "./search-result/search-result.component";

@Component({
    selector: "rask-handelssortiment",
    styleUrls: ["./handelssortiment.component.scss"],
    templateUrl: "./handelssortiment.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        SearchPanelComponent,
        SearchResultComponent,
        ButtonComponent,
        NgbPopover,
        ListSelectedItemsComponent,
        HandelssortimentFileDownloaderComponent,
        TranslatePipe
    ]
})
export class HandelssortimentComponent {
    handelssortiment: ISearchHandelssortimentModel[];
    @ViewChild(SearchResultComponent) searchResultView: SearchResultComponent;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    readonly canCreate = () => this.authenticationService.canEdit();

    create = (): void => {
        this.router.navigate([
            "/handelssortiment",
            "ny"
        ]);
    };

    getFileName  = (id: number) => {
        const row = this.searchResultView.searchResultTable.getSelectedRows().find(x => x.id === id);
        return `${row.namn}_${row.beteckning}`;
    };

    getSelectedHs = () => this.searchResultView.searchResultTable.getSelectedRows();

    getSelectedListItems() {
        return ObjectUtils.isNullOrUndefined(this.searchResultView?.selectedRows) ? [] : this.searchResultView?.selectedRows.map(x => new SelectedListItem(x.id, x.namn, true));
    }

    onhandelssortiment(event) {
        this.handelssortiment = event;
    }

    removeFromSelection(item: SelectedListItem) {
        const filter = (result: any) => result.id === item.id;
        this.searchResultView?.searchResultTable?.removeItemFromSelectionList(filter);
        this.searchResultView?.onCheckedChange();
    }
}
